import React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import styles from "./style.module.css";
import { isEnabled } from "@/utils/featureFlags";

export default class AccountSettings extends React.PureComponent {
  renderHeader() {
    const { selectedTenant, selectedAccount, history, isSampleAccount, accounts, isLoading, checkRefresh } = this.props;

    return (
      <div className={styles.header}>
        <div className={styles.flex}>
          <div className={styles.info}>{"Selected Workspace: "}</div>
          <div className={styles.value}>{selectedTenant ? selectedTenant.fullname : "..."}</div>
        </div>
        <div className={styles.flex}>
          <div className={styles.info}>{"Cloud Accounts: "}</div>
          <div className={styles.value}>{isLoading ? "..." : accounts?.length ? accounts?.length : 0}</div>
        </div>
        <div className={styles.linkWrapper} style={{ height: isLoading ? "23px" : undefined }}>
          {isLoading ? (
            <div className={styles.lHolder}>
              <LoadingIndicator
                style={{
                  width: "20px",
                  height: "18px",
                  transform: "scale(0.40)",
                  margin: "10px 0px 3px 0px"
                }}
              />
            </div>
          ) : accounts?.length ? (
            <>
            <a className={styles.homeLink} onClick={() => history.push("/")}>
              {"Home"}
            </a>
            { isEnabled("internal-debug-token-refresh-button", false) &&
              <a className={styles.homeLink + " px-4"} onClick={() => checkRefresh({ forceRefresh: true })}>{"[Debug: Refresh User Tokens]"}</a>
            }
            </>
          ) : (
            <div>
              <Link className={styles.helpLink} to="/help/aws" target="_blank">
                <FontAwesomeIcon icon={faQuestionCircle} /> {"How do I link my AWS account?"}
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  }
  render() {
    const { view } = this.props;

    return (
      <div className={styles.settings}>
        {this.renderHeader()}
        <div className={styles.view}>{view}</div>
      </div>
    );
  }
}
